import { useAuth } from '@toki/auth';

export function usePermissions() {
  const { state } = useAuth();
  const permissions = state.user?.permissions ?? [];

  return {
    permissions,
    hasPermission: (code: string) => permissions.includes(code),
    hasAnyPermission: (...codes: string[]) => codes.some((c) => permissions.includes(c)),
  };
}
